import React, { useState } from 'react';
import Addnewrepo_sqlite from './addnewrepo_sqlite';
import Addnewrepo_mysql from './addnewrepo_mysql';
import Addnewrepo_postgres from './addnewrepo_postgres';
import Addnewrepo_mssql from './addnewrepo_mssql';

import { Select } from 'antd';

const { Option } = Select;

// Pass-through shell; forwards `error`/`isNameFound` from addNewRepo so the database
// tabs gate on the same shared name validation as every other tab.
const Maindbrepo = (props) => {
    // Define state to hold the selected database type
    const [selectedDbType, setSelectedDbType] = useState('sqlite');

    const handleDbTypeChange = (value) => {
        setSelectedDbType(value);
    };

    return (
        <div className='w-full mx-auto py-2'>
            <div className='w-full flex flex-row mr-3 items-center mb-4'>
                <div className='text-texts-secondary300 mr-3 font-semibold'>
                    Select Database Type
                </div>
                <Select
                    defaultValue='sqlite'
                    style={{ width: 120 }}
                    onChange={handleDbTypeChange}
                >
                    <Option value='sqlite'>SQLite</Option>
                    <Option value='postgres'>Postgres</Option>
                    <Option value='mssql'>MS SQL</Option>
                </Select>
            </div>

            {selectedDbType === 'sqlite' && (
                <div>
                    <Addnewrepo_sqlite
                        reponame={props.reponame}
                        setAddNewMode={props.setAddNewMode}
                        getAllReposData={props.getAllReposData}
                        socket={props.socket}
                        error={props.error}
                        isNameFound={props.isNameFound}
                    ></Addnewrepo_sqlite>
                </div>
            )}
            {selectedDbType === 'postgres' && (
                <div>
                    <Addnewrepo_postgres
                        reponame={props.reponame}
                        setAddNewMode={props.setAddNewMode}
                        getAllReposData={props.getAllReposData}
                        socket={props.socket}
                        error={props.error}
                        isNameFound={props.isNameFound}
                    ></Addnewrepo_postgres>
                </div>
            )}
            {selectedDbType === 'mysql' && (
                <div>
                    <Addnewrepo_mysql></Addnewrepo_mysql>
                </div>
            )}
            {selectedDbType === 'mssql' && (
                <div>
                    <Addnewrepo_mssql
                        reponame={props.reponame}
                        setAddNewMode={props.setAddNewMode}
                        getAllReposData={props.getAllReposData}
                        socket={props.socket}
                        error={props.error}
                        isNameFound={props.isNameFound}
                    ></Addnewrepo_mssql>
                </div>
            )}
        </div>
    );
};

export default Maindbrepo;
